// BDD 02/15/2026 - PWO Healthcheck panel (extracted from AITutorApp.js)
import React from "react";
import { View, Text, Platform, Pressable, TouchableOpacity } from "react-native";

const PwoHealthcheckPanel = ({
  // Build label
  isDarkMode,
  debugBuildLabel,
  // Gate visibility
  user,
  isHealthcheckEnabled,
  // Panel toggle
  pwoQaVisible,
  setPwoQaVisible,
  // QA run status
  pwoQaItems,
  pwoQaResults,
  pwoQaIndex,
  pwoQaRunning,
  pwoQaPaused,
  setPwoQaPaused,
  // Grade selector
  pwoQaGradeId,
  setPwoQaGradeId,
  pwoQaGradeOptions,
  pwoQaGradeRunning,
  hasMultipleGradesForQa,
  // Subject selector
  pwoQaSubjectId,
  setPwoQaSubjectId,
  pwoQaSubjectOptions,
  // Smoke test
  smokeRunning,
  smokeStepIndex,
  smokeResults,
  smokeLastError,
  SMOKE_TEST_PLAN_V1,
  // Functions
  closePwoQaPanel,
  buildPwoQaListForVisibleTopics,
  buildPwoQaListForSelectedSubject,
  startPwoQaRun,
  stopPwoQaRun,
  exportPwoQaJsonl,
  resetPwoQa,
  runPwoQaForSelectedGrade,
  startSmokeRun,
  stopSmokeRun,
  exportSmokeJsonl,
}) => {
  return (
    <>
      {/* BDD 02/11/2026 - show LOCAL/DEV only (nothing for PROD) */}
      {!!debugBuildLabel && (
        <View
          pointerEvents="none"
          style={{
            position: "absolute",
            left: 12,
            bottom: 6,
            paddingHorizontal: 8,
            paddingVertical: 3,
            borderRadius: 8,
            backgroundColor: isDarkMode ? "rgba(15,23,42,0.75)" : "rgba(255,255,255,0.8)",
            borderWidth: 1,
            borderColor: isDarkMode ? "rgba(148,163,184,0.25)" : "rgba(100,116,139,0.25)",
          }}
        >
          <Text style={{ fontSize: 11, opacity: 0.85, color: isDarkMode ? "#e2e8f0" : "#0f172a" }}>
            {debugBuildLabel}
          </Text>
        </View>
      )}

      {/* BDD 02/15/2026 - test/healthCheckpwo */}
      {user?.is_internal_admin && isHealthcheckEnabled && (
        <View
          pointerEvents="box-none"
          style={{
            position: Platform.OS === "web" ? "fixed" : "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 999,  // lowered from 2147483600 — QA panel doesn't need max-int priority
          }}
        >
          {/* Toggle button */}
          <Pressable
            pointerEvents="auto"
            onPressIn={() => console.log("✅ PWO Healthcheck onPressIn")}
            onPress={() => {
              console.log("✅ PWO Healthcheck onPress");
              setPwoQaVisible((v) => !v);
            }}
            style={({ pressed }) => ({
              position: "absolute",
              bottom: 18,
              left: 18,
              paddingHorizontal: 12,
              paddingVertical: 10,
              borderRadius: 12,
              backgroundColor: pressed
                ? "rgba(17, 24, 39, 0.9)"
                : "rgba(17, 24, 39, 0.75)",
              borderWidth: 1,
              borderColor: "rgba(255,255,255,0.12)",
              ...(Platform.OS === "web" ? { cursor: "pointer", userSelect: "none" } : {}),
            })}
          >
            <Text style={{ color: "#fff", fontWeight: "800", fontSize: 12 }}>
              PWO Healthcheck
            </Text>
          </Pressable>

          {/* Panel */}
          {pwoQaVisible && (
            <View
              pointerEvents="auto"
              style={{
                position: "absolute",
                bottom: 62,
                left: 18,
                width: 380,
                backgroundColor: "rgba(0,0,0,0.72)",
                borderWidth: 1,
                borderColor: "rgba(255,255,255,0.14)",
                borderRadius: 14,
                padding: 12,
                ...(Platform.OS === "web"
                  ? {
                      backdropFilter: "blur(14px)",
                      WebkitBackdropFilter: "blur(14px)",
                      boxShadow: "0 10px 30px rgba(0,0,0,0.35)",
                    }
                  : {}),
              }}
            >
              {/* Header row with Close */}
              <View style={{ flexDirection: "row", alignItems: "center", justifyContent: "space-between", marginBottom: 6 }}>
                <Text style={{ color: "#fff", fontWeight: "900", fontSize: 13 }}>
                  PWO Runner (WebGL)
                </Text>

                <Pressable
                  onPress={closePwoQaPanel}
                  style={{
                    paddingHorizontal: 10,
                    paddingVertical: 6,
                    borderRadius: 10,
                    backgroundColor: "rgba(255,255,255,0.10)",
                    ...(Platform.OS === "web" ? { cursor: "pointer", userSelect: "none" } : {}),
                  }}
                >
                  <Text style={{ color: "#fff", fontWeight: "900", fontSize: 12 }}>Close</Text>
                </Pressable>
              </View>

              <Text style={{ color: "rgba(255,255,255,0.85)", fontSize: 12, marginBottom: 8 }}>
                Items: {pwoQaItems.length} | Done: {pwoQaResults.length} | Next: {pwoQaIndex + 1}
              </Text>

              {/* BDD 02/20/2026 - PWO QA - Grade scope test/healthCheckpwo */}
              {Platform.OS === "web" && hasMultipleGradesForQa && (
                <View style={{ marginBottom: 10 }}>
                  <Text style={{ color: "rgba(255,255,255,0.75)", fontSize: 11, marginBottom: 6 }}>
                    Grade scope
                  </Text>

                  <select
                    value={pwoQaGradeId}
                    onChange={(e) => setPwoQaGradeId(e.target.value)}
                    style={{
                      width: "100%",
                      padding: "8px 10px",
                      borderRadius: 10,
                      border: "1px solid rgba(255,255,255,0.18)",
                      background: "rgba(255,255,255,0.08)",
                      color: "white",
                      outline: "none",
                    }}
                  >
                    {(pwoQaGradeOptions || []).map((opt) => (
                      <option key={opt.id} value={opt.id} style={{ color: "black" }}>
                        {opt.label}
                      </option>
                    ))}
                  </select>
                </View>
              )}

              {/* Subject selector (web-only, since this is WebGL runner anyway) */}
              {Platform.OS === "web" && (
                <View style={{ marginBottom: 10 }}>
                  <Text style={{ color: "rgba(255,255,255,0.75)", fontSize: 11, marginBottom: 6 }}>
                    Subject scope
                  </Text>

                  <select
                    value={pwoQaSubjectId}
                    onChange={(e) => setPwoQaSubjectId(e.target.value)}
                    style={{
                      width: "100%",
                      padding: "8px 10px",
                      borderRadius: 10,
                      border: "1px solid rgba(255,255,255,0.18)",
                      background: "rgba(255,255,255,0.08)",
                      color: "white",
                      outline: "none",
                    }}
                  >
                    {(pwoQaSubjectOptions || []).map((opt) => (
                      <option key={opt.id} value={opt.id} style={{ color: "black" }}>
                        {opt.label}
                      </option>
                    ))}
                  </select>

                  <Text style={{ color: "rgba(255,255,255,0.55)", fontSize: 10, marginTop: 6 }}>
                    Note: Build List (Subject) does not require expanding chapters/topics.
                  </Text>
                </View>
              )}

              {/* BDD 02/20/2026 - smoketest Smoke Test Runner */}
              <View style={{ marginTop: 10, marginBottom: 8 }}>
                <Text style={{ color: "#fff", fontWeight: "900", fontSize: 12, marginBottom: 6 }}>
                  Smoke Test
                </Text>

                <View style={{ flexDirection: "row", flexWrap: "wrap", alignItems: "center" }}>
                  <Pressable
                    onPress={() => startSmokeRun()}
                    disabled={!!smokeRunning}
                    style={{
                      padding: 8,
                      borderRadius: 10,
                      backgroundColor: "rgba(34,197,94,0.25)",
                      marginRight: 8,
                      marginBottom: 8,
                      opacity: smokeRunning ? 0.5 : 1,
                      ...(Platform.OS === "web" ? { cursor: "pointer", userSelect: "none" } : {}),
                    }}
                  >
                    <Text style={{ color: "#fff", fontWeight: "900" }}>
                      {smokeRunning ? "Running..." : "Run Smoke"}
                    </Text>
                  </Pressable>

                  <Pressable
                    onPress={() => stopSmokeRun()}
                    disabled={!smokeRunning}
                    style={{
                      padding: 8,
                      borderRadius: 10,
                      backgroundColor: "rgba(239,68,68,0.25)",
                      marginRight: 8,
                      marginBottom: 8,
                      opacity: smokeRunning ? 1 : 0.5,
                      ...(Platform.OS === "web" ? { cursor: "pointer", userSelect: "none" } : {}),
                    }}
                  >
                    <Text style={{ color: "#fff", fontWeight: "900" }}>Stop</Text>
                  </Pressable>

                  <Pressable
                    onPress={() => exportSmokeJsonl(SMOKE_TEST_PLAN_V1?.name || "smoke")}
                    disabled={!smokeResults?.length}
                    style={{
                      padding: 8,
                      borderRadius: 10,
                      backgroundColor: "rgba(59,130,246,0.25)",
                      marginRight: 8,
                      marginBottom: 8,
                      opacity: smokeResults?.length ? 1 : 0.5,
                      ...(Platform.OS === "web" ? { cursor: "pointer", userSelect: "none" } : {}),
                    }}
                  >
                    <Text style={{ color: "#fff", fontWeight: "900" }}>Download JSONL</Text>
                  </Pressable>
                </View>

                <Text style={{ color: "rgba(255,255,255,0.75)", fontSize: 11 }}>
                  Steps: {SMOKE_TEST_PLAN_V1?.steps?.length || 0} | Done: {smokeResults?.length || 0} | Next: {smokeStepIndex + 1}
                </Text>

                {!!smokeLastError && (
                  <Text style={{ marginTop: 6, color: "orange", fontSize: 11 }}>
                    Smoke error: {smokeLastError}
                  </Text>
                )}
              </View>

              <View style={{ flexDirection: "row", flexWrap: "wrap", alignItems: "center" }}>
                {/* Chapter-scoped build */}
                <TouchableOpacity
                  onPress={buildPwoQaListForVisibleTopics}
                  style={{ padding: 8, borderRadius: 10, backgroundColor: "rgba(255,255,255,0.10)", marginRight: 8, marginBottom: 8 }}
                >
                  <Text style={{ color: "#fff", fontWeight: "800" }}>Build List (Chapter)</Text>
                </TouchableOpacity>

                {/* Subject-scoped build */}
                <TouchableOpacity
                  onPress={buildPwoQaListForSelectedSubject}
                  style={{ padding: 8, borderRadius: 10, backgroundColor: "rgba(255,255,255,0.10)", marginRight: 8, marginBottom: 8 }}
                >
                  <Text style={{ color: "#fff", fontWeight: "800" }}>Build List (Subject)</Text>
                </TouchableOpacity>

                {!pwoQaRunning ? (
                  <Pressable
                    onPress={() => {
                      console.log("Start clicked");
                      startPwoQaRun();
                    }}
                    style={{ padding: 8, borderRadius: 10, backgroundColor: "rgba(34,197,94,0.25)", marginRight: 8, marginBottom: 8 }}
                  >
                    <Text style={{ color: "#fff", fontWeight: "900" }}>Start</Text>
                  </Pressable>
                ) : (
                  <Pressable
                    onPress={() => setPwoQaPaused((p) => !p)}
                    style={{ padding: 8, borderRadius: 10, backgroundColor: "rgba(251,191,36,0.25)", marginRight: 8, marginBottom: 8 }}
                  >
                    <Text style={{ color: "#fff", fontWeight: "900" }}>{pwoQaPaused ? "Resume" : "Pause"}</Text>
                  </Pressable>
                )}

                <Pressable
                  onPress={stopPwoQaRun}
                  style={{ padding: 8, borderRadius: 10, backgroundColor: "rgba(239,68,68,0.25)", marginRight: 8, marginBottom: 8 }}
                >
                  <Text style={{ color: "#fff", fontWeight: "900" }}>Stop</Text>
                </Pressable>

                <Pressable
                  onPress={exportPwoQaJsonl}
                  style={{ padding: 8, borderRadius: 10, backgroundColor: "rgba(59,130,246,0.25)", marginRight: 8, marginBottom: 8 }}
                >
                  <Text style={{ color: "#fff", fontWeight: "900" }}>Download JSONL</Text>
                </Pressable>

                <Pressable
                  onPress={resetPwoQa}
                  style={{ padding: 8, borderRadius: 10, backgroundColor: "rgba(255,255,255,0.10)", marginRight: 8, marginBottom: 8 }}
                >
                  <Text style={{ color: "#fff", fontWeight: "800" }}>Reset</Text>
                </Pressable>

                <Pressable
                  onPress={runPwoQaForSelectedGrade}
                  disabled={pwoQaRunning || pwoQaGradeRunning}
                  style={{
                    padding: 8,
                    borderRadius: 10,
                    backgroundColor: "rgba(255,255,255,0.10)",
                    marginRight: 8,
                    marginBottom: 8,
                    opacity: (pwoQaRunning || pwoQaGradeRunning) ? 0.5 : 1,
                    ...(Platform.OS === "web" ? { cursor: "pointer", userSelect: "none" } : {}),
                  }}
                >
                  <Text style={{ color: "#fff", fontWeight: "800" }}>
                    {pwoQaGradeRunning ? "Running Grade..." : "Run Grade (All Subjects)"}
                  </Text>
                </Pressable>
              </View>
            </View>
          )}
        </View>
      )}
    </>
  );
};

export default PwoHealthcheckPanel;
